<div class="entities-bar">
  <h1>Detected Personal Information</h1>
  <div class="divider"></div>
  <div  class="entities">
    <div *ngFor="let label of labels">
      <app-entities-bar-row *ngIf="groupedEntities[label.display_name] !== undefined" [entities]="groupedEntities[label.display_name]" [label]="label" (deleteEntity)="delete($event)"></app-entities-bar-row>
    </div>
  </div>
  <button (click)="download()">Download</button>
  <button [disabled]="!hasEntityChange" (click)="saveEntities()">Save changes</button>
</div>
